import { MenuItem, Select } from '@mui/material';
import React from 'react';
import { sensorTypeOptions } from '@innovyze/stylovyze/lib/components/SensorTypeDropdownSelect/SensorTypes';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts/GlobalizationProvider';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const SensorTypeDropdownSelect = ({ dataCy, supportNoSensorType, defaultValue = '', ...props }) => {
    const { t } = useGlobalization();
    return (React.createElement(Select, { "data-cy": dataCy, ...props, defaultValue: defaultValue },
        supportNoSensorType && (React.createElement(MenuItem, { value: "No Sensor Type" }, t('No Sensor Type'))),
        sensorTypeOptions(t).map(({ label, value }) => (React.createElement(MenuItem, { key: value, value: value }, label)))));
};
export default SensorTypeDropdownSelect;
